'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'opossum';
var width = 640;
var height = 512;
var aliases = ["possum"];
var unicode = 'e87c';
var svgPathData = 'M288.5 0c91.5 0 171.7 48 216.9 120.2 12.5 .7 24.5 3.2 35.7 7.2l17.4-17.4c18.7-18.7 49.1-18.7 67.9 0s18.7 49.1 0 67.9L612.3 192c7.8 16.4 12.2 34.7 12.2 54 0 27.3-8.8 53.8-25.2 75.6L528.5 416c-7.6 10.1-19.4 16-32 16s-24.4-5.9-32-16l-96 0 0-24c0-40.8-27.8-75-65.5-85-10.2-74-73.7-131-150.5-131-13.3 0-24 10.7-24 24s10.7 24 24 24c57.4 0 104 46.6 104 104 0 13.3 10.7 24 24 24 22.1 0 40 17.9 40 40l0 24-32 0c-33.6 0-64.7-10.3-90.4-27.9-10.9-7.5-25.8-4.7-33.3 6.2-7.5 10.9-4.7 25.8 6.2 33.3 33.4 22.9 74 36.4 117.5 36.4l199.6 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-199.6 0c-141.4 0-256-114.6-256-256S147.1 0 288.5 0zM510.2 194.3c-3.6 3.6-8.5 5.7-13.7 5.7s-10-2-13.7-5.7l-19.7-19.8c-27.4 12.1-46.6 39.5-46.6 71.4 0 16.9 5.5 33.3 15.6 46.8l44.4 59.2 39.9 0 44.4-59.2c10.1-13.5 15.6-29.9 15.6-46.8 0-31.9-19.2-59.3-46.6-71.4l-19.7 19.8zM464.5 260a20 20 0 1 1 0-40 20 20 0 1 1 0 40zm64 0a20 20 0 1 1 0-40 20 20 0 1 1 0 40zM434.4 110.1c-18.7-18.7-49.1-18.7-67.9 0s-18.7 49.1 0 67.9L380.6 192c14.2-29.9 39.8-53.3 71.2-64.6l-17.4-17.4z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faOpossum = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;